import { AnimationStateEnum, AnimationVariantEnum } from 'enums/animation'

export const ANIMATION_ROOT_ATTRIBUTE = 'data-animation'
export const ANIMATION_REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)'
// Triggers a fifth into the viewport: on a slow scroll the reveal must end while the element is well in view.
export const ANIMATION_ROOT_MARGIN = '0px 0px -20% 0px'
// A ratio threshold is unreachable for elements taller than the root: they would never reveal.
export const ANIMATION_THRESHOLD = 0
export const ANIMATION_STAGGER_MS = 80
export const ANIMATION_MAX_STAGGER_MS = 400
export const ANIMATION_FAILSAFE_MS = 2500
export const ANIMATION_SCROLL_SETTLE_FRAMES = 3
export const ANIMATION_SCROLL_SETTLE_TIMEOUT_MS = 1500

export const ANIMATION_SELECTOR = '[data-animate-group], [data-animate]:not([data-animate-group] [data-animate])'
export const ANIMATION_ELEMENT_SELECTOR = '[data-animate]'

// Written in full: Tailwind only detects literal class names, and these are applied at runtime.
const ANIMATION_CLASSES: Record<AnimationVariantEnum, string> = {
  [AnimationVariantEnum.FADE_UP]: 'animate-fade-up',
  [AnimationVariantEnum.FADE_LEFT]: 'animate-fade-left',
  [AnimationVariantEnum.FADE_RIGHT]: 'animate-fade-right',
  [AnimationVariantEnum.ZOOM]: 'animate-zoom-in'
}

// Runs before first paint and cancels itself: content stays visible if scripting or the engine fails.
export const ANIMATION_BOOTSTRAP_SCRIPT = `(function(){var r=document.documentElement;if(window.matchMedia('${ANIMATION_REDUCED_MOTION_QUERY}').matches)return;r.setAttribute('${ANIMATION_ROOT_ATTRIBUTE}','${AnimationStateEnum.PENDING}');setTimeout(function(){if(r.getAttribute('${ANIMATION_ROOT_ATTRIBUTE}')==='${AnimationStateEnum.PENDING}')r.removeAttribute('${ANIMATION_ROOT_ATTRIBUTE}')},${ANIMATION_FAILSAFE_MS})})()`

export function getAnimationClass(variant?: string): string {
  const animationClass = ANIMATION_CLASSES[variant as AnimationVariantEnum]

  return animationClass ?? ANIMATION_CLASSES[AnimationVariantEnum.FADE_UP]
}

// Capped so a long list never feels slow.
export function getStaggerDelay(index: number): number {
  return Math.min(index * ANIMATION_STAGGER_MS, ANIMATION_MAX_STAGGER_MS)
}
